// import React, { useState } from 'react';
// import { Carousel } from 'react-bootstrap';
// import { Container, Row, Col, Form, Button, Modal } from 'react-bootstrap';
// import Header from '../../Header/Header';
// import TopNavbar from '../TopNavbar'
// import Footer from '../../Footer/Footer'
// import banner11 from '../img/banner11.png'

// function Upload() {

//     const [showModal, setShowModal] = useState(false);

//     const handleSubmit = (event) => {
//         event.preventDefault();
//         setShowModal(true);
//     };


//     return (
//         <div>
//             <Header />
//             <TopNavbar />

//             <div className="banner-area">
//                 <Carousel id="bootcarousel" className="text-light heading-uppercase animate_text" controls indicators={false}>
//                     <Carousel.Item className="bg-cover img-fluid">
//                         <img src={banner11} className="d-block w-100" alt="Second slide" />
//                     </Carousel.Item>
//                 </Carousel>
//             </div>
//             <br></br>
//             <Container>
//                 <Row className="justify-content-md-center">
//                     <Col xs={12} md={8}>
//                         <h4 style={{ textAlign: 'center', marginLeft: '20px' }}>UPLOADS HERE</h4>
//                         <Form onSubmit={handleSubmit}>
//                             <Form.Group controlId="image1" data-aos="fade-up">
//                                 <Form.Label><b>Upload Photo (Please upload only PNG, JPG, GIF AND JPEG Files and size must be 2 MB)<sup>*</sup></b></Form.Label>
//                                 <Form.Control type="file" accept="image/*" required />
//                             </Form.Group><br></br>

//                             <Form.Group controlId="text" data-aos="fade-up">
//                                 <Form.Label><b>Add your Caption Here<sup>*</sup></b></Form.Label>
//                                 <Form.Control as="textarea" rows={1} required />
//                             </Form.Group><br></br>
//                             <Row>
//                                 <Col xs={12} md={6}>
//                                     <Form.Group controlId="district" data-aos="fade-up">
//                                         <Form.Label ><b>Districts<sup>*</sup></b></Form.Label>
//                                         <Form.Control as="select" required>
//                                             <option value="">---SELECT DISTRICT---</option>
//                                             <option value="320A">320A</option>
//                                             <option value="320B">320B</option>
//                                             <option value="320C">320C</option>
//                                             <option value="320D">320D</option>
//                                             <option value="320E">320E</option>
//                                             <option value="320F">320F</option>
//                                             <option value="320G">320G</option>
//                                             <option value="320H">320H</option>
//                                         </Form.Control>
//                                     </Form.Group>
//                                 </Col>
//                                 <Col xs={12} md={6}>
//                                     <Form.Group controlId="activity" data-aos="fade-up">
//                                         <Form.Label><b>Service Activity<sup>*</sup></b></Form.Label>
//                                         <Form.Control as="select" required>
//                                             <option value="">---Select Activity---</option>
//                                             <option value="Hunger-Relief">Hunger Relief</option>
//                                             <option value="Environment">Environment</option>
//                                             <option value="Childhood-Cancer">Childhood Cancer</option>
//                                             <option value="Medical-Camps">Medical Camps</option>
//                                             <option value="Seminars">Seminars</option>
//                                             <option value="Rallies-Awareness">Rellies & Awareness</option>
//                                             <option value="Youth-Empowerment">Youth Empowerment</option>
//                                             <option value="Diabetes">Diabets</option>
//                                             <option value="Leo">Leo</option>
//                                             <option value="Quest">Quest</option>
//                                             <option value="Leadership Training">Leadership Training</option>
//                                             <option value="Permanent Projects">Permanent Projects</option>
//                                             <option value="Vision">Vision</option>
//                                             <option value="Other">Other</option>
//                                         </Form.Control>
//                                     </Form.Group><br></br>
//                                 </Col>
//                             </Row><br></br>

//                             <Button data-aos="fade-up" variant="primary" type="submit">UPLOAD</Button>
//                         </Form><br></br>

//                     </Col>
//                 </Row>
//                 <Modal show={showModal} onHide={() => setShowModal(false)} id="success">
//                     <Modal.Header closeButton>
//                         <Modal.Title>Modal title</Modal.Title>
//                     </Modal.Header>
//                     <Modal.Body>
//                         <b>Image Uploaded successfully</b>
//                     </Modal.Body>
//                     <Modal.Footer>
//                         <Button variant="secondary" onClick={() => setShowModal(false)}>Close</Button>
//                     </Modal.Footer>
//                 </Modal>
//             </Container>


//             <Footer />
//         </div>
//     )
// }

// export default Upload













// import { useState, useRef } from "react"
// import TopNavbar from "../TopNavbar"
// import Footer from "../../Footer/Footer"

// const districtsList = ["320A", "320B", "320C", "320D", "320E", "320F", "320G", "320H", "GET", "GMT", "GLT", "GST", "MARKETING", "LCIF", "FWC", "LEO", "QUEST"];
// const serviceActivities = ["Hunger Relief", "Environment", "Childhood Cancer", "Medical Camps", "Seminars", "Rellies & Awareness", "Youth Empowerment", "Diabets", "Leo", "Quest", "Leadership Training", "Permanent Projects", "Vision", "Other",]

// // Define your backend API base URL
// const API_BASE_URL = "https://api.lionsmd320.org/pages/api/api/activities"

// export default function Upload() {
//     const [state, setState] = useState("idle")
//     const [progress, setProgress] = useState(0)
//     const [dragOver, setDragOver] = useState(false)
//     const [filename, setFilename] = useState("")
//     const [errorMessage, setErrorMessage] = useState("")

//     // Form fields
//     const [caption, setCaption] = useState("")
//     const [district, setDistrict] = useState("")
//     const [activity, setActivity] = useState("")
//     const [selectedFile, setSelectedFile] = useState(null)

//     // Optional editing ID state if used dynamically
//     const [editingId, setEditingId] = useState(null)

//     const inputRef = useRef(null)

//     const validateAndSetFile = (file) => {
//         const validExtensions = ["image/jpeg", "image/jpg", "image/png", "image/gif"]
//         if (!validExtensions.includes(file.type)) {
//             setErrorMessage("Please upload only PNG, JPG, GIF AND JPEG files.")
//             setState("error")
//             return
//         }

//         const maxSize = 2 * 1024 * 1024
//         if (file.size > maxSize) {
//             setErrorMessage("File size must be 2 MB or less.")
//             setState("error")
//             return
//         }

//         setErrorMessage("")
//         setSelectedFile(file)
//         setFilename(file.name)
//     }

//     const handleFile = (file) => {
//         validateAndSetFile(file)
//     }

//     const handleDrop = (e) => {
//         e.preventDefault()
//         setDragOver(false)
//         const file = e.dataTransfer.files[0]
//         if (file) handleFile(file)
//     }

//     const handleChange = (e) => {
//         const file = e.target.files?.[0]
//         if (file) handleFile(file)
//     }

//     // Dummy placeholder function for fetching activities if called after success
//     const fetchActivities = async () => {
//         try {
//             await fetch(API_BASE_URL)
//         } catch (err) {
//             console.error("Failed to fetch activities list:", err)
//         }
//     }

//     const handleSubmit = async (e) => {
//         e.preventDefault()
//         if (!editingId && !selectedFile) {
//             setErrorMessage("Please select a valid photo file.")
//             setState("error")
//             return
//         }
//         if (!district || !activity || !caption) {
//             setErrorMessage("Please fill all required fields.")
//             setState("error")
//             return
//         }

//         setState("uploading")
//         setProgress(30) // Initial simulated progress

//         const formData = new FormData()
//         formData.append("caption", caption)
//         formData.append("district", district)
//         formData.append("activity", activity)
//         if (selectedFile) {
//             formData.append("photo", selectedFile)
//         }

//         try {
//             setProgress(60)
//             let res;
//             if (editingId) {
//                 res = await fetch(`${API_BASE_URL}/${editingId}`, {
//                     method: "PUT",
//                     body: formData,
//                 })
//             } else {
//                 res = await fetch(API_BASE_URL, {
//                     method: "POST",
//                     body: formData,
//                 })
//             }

//             if (!res.ok) throw new Error("Operation failed on the server")

//             setProgress(100)
//             setState("success")
//             fetchActivities()
//         } catch (err) {
//             setErrorMessage(err.message)
//             setState("error")
//         }
//     }

//     const reset = () => {
//         setState("idle")
//         setProgress(0)
//         setFilename("")
//         setCaption("")
//         setDistrict("")
//         setActivity("")
//         setSelectedFile(null)
//         setErrorMessage("")
//         setEditingId(null)
//         if (inputRef.current) inputRef.current.value = ""
//     }

//     return (
//         <>
//             <TopNavbar />
//             <div style={{ fontFamily: "inherit" }}>

//                 <div style={{ backgroundColor: "#0067B1", padding: "48px 0" }}>
//                     <div style={{ maxWidth: "1280px", margin: "0 auto", paddingLeft: "16px", paddingRight: "16px" }}>
//                         <nav style={{ display: "flex", alignItems: "center", gap: "8px", fontSize: "14px", color: "rgba(255, 255, 255, 0.8)", marginBottom: "12px" }}>
//                             <a href="/" style={{ color: "#ffffff", textDecoration: "none" }}>Home</a>
//                             <span>/</span>
//                             <span style={{ color: "rgba(255, 255, 255, 0.6)" }}>Upload</span>
//                         </nav>
//                         <h1 style={{ fontSize: "36px", fontWeight: 800, color: "#ffffff", marginTop: "16px" }}>Upload Service Activity Photo</h1>
//                         <p style={{ color: "rgba(255, 255, 255, 0.7)", marginTop: "8px", fontSize: "16px" }}>Submit district service activities, photos, and reports to MD 320.</p>
//                     </div>
//                 </div>

//                 <section style={{ padding: "64px 0", backgroundColor: "#f9fafb", minHeight: "60vh" }}>
//                     <div style={{ maxWidth: "672px", margin: "0 auto", paddingLeft: "16px", paddingRight: "16px" }}>
//                         {state === "idle" && (
//                             <form onSubmit={handleSubmit} style={{ backgroundColor: "#ffffff", borderRadius: "16px", border: "1px solid #f3f4f6", boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)", padding: "32px", display: "flex", flexDirection: "column", gap: "24px" }}>
//                                 <div>
//                                     <label style={{ display: "block", fontWeight: 700, color: "#1f2937", marginBottom: "8px" }}>Upload Photo <span style={{ color: "#ef4444" }}>*</span></label>
//                                     <p style={{ fontSize: "12px", color: "#9ca3af", marginBottom: "12px" }}>Please upload only PNG, JPG, GIF AND JPEG Files and size must be 2 MB</p>
//                                     <div style={{ position: "relative", borderRadius: "12px", border: `2px dashed ${dragOver ? "#0067B1" : "#e5e7eb"}`, transition: "all 0.2s", padding: "32px", textAlign: "center", cursor: "pointer", backgroundColor: dragOver ? "#f0f7ff" : "#ffffff", }} onDragOver={(e) => { e.preventDefault(); setDragOver(true) }} onDragLeave={() => setDragOver(false)} onDrop={handleDrop} onClick={() => inputRef.current?.click()}>
//                                         <input ref={inputRef} type="file" style={{ display: "none" }} onChange={handleChange} accept=".png,.jpg,.jpeg,.gif" />
//                                         <div style={{ width: "64px", height: "64px", backgroundColor: "#f0f7ff", borderRadius: "16px", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px auto", color: "#0067B1" }}>
//                                             <svg style={{ width: "32px", height: "32px" }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                                                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" />
//                                             </svg>
//                                         </div>
//                                         {Boolean(filename) ? (
//                                             <p style={{ fontSize: "14px", fontWeight: 600, color: "#0067B1" }}>{filename}</p>
//                                         ) : (
//                                             <>
//                                                 <p style={{ fontSize: "14px", fontWeight: 500, color: "#374151", marginBottom: "4px" }}>Drag and drop your photo here, or click to browse</p>
//                                                 <p style={{ fontSize: "12px", color: "#9ca3af" }}>Max size: 2 MB</p>
//                                             </>
//                                         )}
//                                     </div>
//                                 </div>

//                                 <div>
//                                     <label style={{ display: "block", fontWeight: 700, color: "#1f2937", marginBottom: "8px" }} htmlFor="caption">Add your Caption Here <span style={{ color: "#ef4444" }}>*</span></label>
//                                     <textarea id="caption" rows={3} value={caption} onChange={(e) => setCaption(e.target.value)} placeholder="Provide a short description or caption for this photo..." required style={{ width: "100%", border: "1px solid #e5e7eb", borderRadius: "8px", padding: "12px", fontSize: "14px", outline: "none", boxSizing: "border-box", }} />
//                                 </div>

//                                 <div>
//                                     <label style={{ display: "block", fontWeight: 700, color: "#1f2937", marginBottom: "8px" }} htmlFor="district">Districts <span style={{ color: "#ef4444" }}>*</span></label>
//                                     <select id="district" value={district} onChange={(e) => setDistrict(e.target.value)} required style={{ width: "100%", border: "1px solid #e5e7eb", borderRadius: "8px", padding: "12px", fontSize: "14px", backgroundColor: "#ffffff", outline: "none", color: "#374151", boxSizing: "border-box", }}>
//                                         <option value="">---SELECT DISTRICT---</option>
//                                         {districtsList.map((d) => (<option key={d} value={d}>{d}</option>))}
//                                     </select>
//                                 </div>

//                                 <div>
//                                     <label style={{ display: "block", fontWeight: 700, color: "#1f2937", marginBottom: "8px" }} htmlFor="activity">Service Activity <span style={{ color: "#ef4444" }}>*</span></label>
//                                     <select id="activity" value={activity} onChange={(e) => setActivity(e.target.value)} required style={{ width: "100%", border: "1px solid #e5e7eb", borderRadius: "8px", padding: "12px", fontSize: "14px", backgroundColor: "#ffffff", outline: "none", color: "#374151", boxSizing: "border-box", }}>
//                                         <option value="">---Select Activity---</option>
//                                         {serviceActivities.map((act) => (
//                                             <option key={act} value={act}>{act}</option>
//                                         ))}
//                                     </select>
//                                 </div>

//                                 <button type="submit" style={{ width: "100%", backgroundColor: "#FFD500", color: "#0067B1", fontWeight: 700, padding: "14px", borderRadius: "8px", letterSpacing: "0.05em", border: "none", cursor: "pointer", boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1)", textAlign: "center", }}>Submit</button>
//                             </form>
//                         )}

//                         {state === "uploading" && (
//                             <div style={{ backgroundColor: "#ffffff", borderRadius: "16px", border: "1px solid #f3f4f6", boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)", padding: "40px", textAlign: "center" }}>
//                                 <div style={{ width: "64px", height: "64px", backgroundColor: "#f0f7ff", borderRadius: "16px", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 20px auto" }}>
//                                     <svg style={{ width: "28px", height: "28px", color: "#0067B1" }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" />
//                                     </svg>
//                                 </div>
//                                 <h2 style={{ fontSize: "20px", fontWeight: 800, color: "#0067B1", marginBottom: "4px" }}>Uploading...</h2>
//                                 <p style={{ color: "#9ca3af", fontSize: "14px", marginBottom: "24px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: "320px", margin: "0 auto 24px auto" }}>{filename}</p>
//                                 <div style={{ width: "100%", backgroundColor: "#f3f4f6", borderRadius: "9999px", height: "10px", marginBottom: "8px", overflow: "hidden" }}>
//                                     <div style={{ backgroundColor: "#0067B1", height: "10px", borderRadius: "9999px", transition: "width 0.3s", width: `${Math.min(progress, 100)}%`, }} />
//                                 </div>
//                                 <p style={{ fontSize: "12px", color: "#9ca3af", fontWeight: 500 }}>{Math.min(progress, 100)}% complete</p>
//                             </div>
//                         )}

//                         {state === "success" && (
//                             <div style={{ backgroundColor: "#ffffff", borderRadius: "16px", border: "1px solid #d1fae5", boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)", padding: "40px", textAlign: "center" }}>
//                                 <div style={{ width: "64px", height: "64px", backgroundColor: "#ecfdf5", borderRadius: "16px", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 20px auto" }}>
//                                     <svg style={{ width: "32px", height: "32px", color: "#10b981" }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
//                                     </svg>
//                                 </div>
//                                 <h2 style={{ fontSize: "24px", fontWeight: 800, color: "#111827", marginBottom: "8px" }}>Upload Successful</h2>
//                                 <p style={{ color: "#6b7280", fontSize: "14px", marginBottom: "4px" }}>Your service activity photo has been received by MD 320.</p>
//                                 <p style={{ color: "#9ca3af", fontSize: "12px", marginBottom: "28px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: "320px", margin: "0 auto 28px auto" }}>{filename}</p>

//                                 <div style={{ backgroundColor: "#f9fafb", borderRadius: "8px", padding: "16px", textAlign: "left", marginBottom: "28px" }}>
//                                     <div style={{ fontSize: "12px", fontWeight: 700, letterSpacing: "0.05em", textTransform: "uppercase", color: "#9ca3af", marginBottom: "8px" }}>Submission Details</div>
//                                     <div style={{ fontSize: "12px", color: "#4b5563", marginBottom: "4px" }}><strong>District:</strong> {district}</div>
//                                     <div style={{ fontSize: "12px", color: "#4b5563", marginBottom: "4px" }}><strong>Activity:</strong> {activity}</div>
//                                     <div style={{ fontSize: "12px", fontFamily: "monospace", color: "#374151", marginTop: "8px" }}><strong>Ref ID:</strong> MD320-{Date.now().toString(36).toUpperCase()}</div>
//                                 </div>

//                                 <button onClick={reset} style={{ backgroundColor: "#0067B1", color: "#ffffff", fontWeight: 700, padding: "12px 28px", borderRadius: "8px", letterSpacing: "0.05em", border: "none", cursor: "pointer", }}>Upload Another</button>
//                             </div>
//                         )}

//                         {state === "error" && (
//                             <div style={{ backgroundColor: "#ffffff", borderRadius: "16px", border: "1px solid #fee2e2", boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)", padding: "40px", textAlign: "center" }}>
//                                 <div style={{ width: "64px", height: "64px", backgroundColor: "#fef2f2", borderRadius: "16px", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 20px auto" }}>
//                                     <svg style={{ width: "32px", height: "32px", color: "#ef4444" }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
//                                     </svg>
//                                 </div>
//                                 <h2 style={{ fontSize: "24px", fontWeight: 800, color: "#111827", marginBottom: "8px" }}>Upload Failed</h2>
//                                 <p style={{ color: "#6b7280", fontSize: "14px", marginBottom: "24px" }}>{errorMessage || "Something went wrong. Please check your file requirements and try again."}</p>

//                                 <div style={{ display: "flex", gap: "12px", justifyContent: "center" }}>
//                                     <button onClick={() => { setState("idle"); setFilename(""); setSelectedFile(null); }} style={{ backgroundColor: "#0067B1", color: "#ffffff", fontWeight: 700, padding: "10px 24px", borderRadius: "8px", letterSpacing: "0.05em", border: "none", cursor: "pointer", }}>Try Again</button>
//                                     <button onClick={reset} style={{ backgroundColor: "transparent", border: "1px solid #e5e7eb", color: "#4b5563", fontWeight: 600, padding: "10px 24px", borderRadius: "8px", cursor: "pointer", }}>Cancel</button>
//                                 </div>
//                             </div>
//                         )}

//                         {state === "idle" && (
//                             <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))", gap: "16px", marginTop: "32px" }}>
//                                 {[
//                                     { icon: "🔒", title: "Secure Transfer", desc: "All uploads are encrypted in transit and at rest." },
//                                     { icon: "⚡", title: "Fast Processing", desc: "Photos are processed and cataloged within minutes." },
//                                     { icon: "📋", title: "Organized Storage", desc: "Files are automatically categorized by district and activity." },
//                                 ].map((item) => (
//                                     <div key={item.title} style={{ backgroundColor: "#ffffff", borderRadius: "12px", padding: "20px", border: "1px solid #f3f4f6", textAlign: "center" }}>
//                                         <div style={{ fontSize: "24px", marginBottom: "8px" }}>{item.icon}</div>
//                                         <div style={{ fontWeight: 600, color: "#1f2937", fontSize: "14px", marginBottom: "4px" }}>{item.title}</div>
//                                         <div style={{ color: "#9ca3af", fontSize: "12px", lineHeight: "1.5" }}>{item.desc}</div>
//                                     </div>
//                                 ))}
//                             </div>
//                         )}
//                     </div>
//                 </section>
//             </div>
//             <Footer />
//         </>
//     )
// }













import { useState, useRef } from "react"
import TopNavbar from "../TopNavbar"
import Footer from "../../Footer/Footer"

const districtsList = ["320A", "320B", "320C", "320D", "320E", "320F", "320G", "320H", "GET", "GMT", "GLT", "GST", "MARKETING", "LCIF", "FWC", "LEO", "QUEST"];
const serviceActivities = ["Hunger Relief", "Environment", "Childhood Cancer", "Medical Camps", "Seminars", "Rellies & Awareness", "Youth Empowerment", "Diabets", "Leo", "Quest", "Leadership Training", "Permanent Projects", "Vision", "Other"]

// Define your backend API base URL
const API_BASE_URL = "https://api.lionsmd320.org/pages/api/api/activities"

export default function Upload() {
    const [state, setState] = useState("idle")
    const [progress, setProgress] = useState(0)
    const [dragOver, setDragOver] = useState(false)
    const [filename, setFilename] = useState("")
    const [errorMessage, setErrorMessage] = useState("")

    // Form fields
    const [caption, setCaption] = useState("")
    const [district, setDistrict] = useState("")
    const [activity, setActivity] = useState("")
    const [selectedFile, setSelectedFile] = useState(null)

    // Optional editing ID state if used dynamically
    const [editingId, setEditingId] = useState(null)

    const inputRef = useRef(null)

    const validateAndSetFile = (file) => {
        const validExtensions = ["image/jpeg", "image/jpg", "image/png", "image/gif"]
        if (!validExtensions.includes(file.type)) {
            setErrorMessage("Please upload only PNG, JPG, GIF AND JPEG files.")
            setState("error")
            return
        }

        const maxSize = 2 * 1024 * 1024
        if (file.size > maxSize) {
            setErrorMessage("File size must be 2 MB or less.")
            setState("error")
            return
        }

        setErrorMessage("")
        setSelectedFile(file)
        setFilename(file.name)
    }

    const handleFile = (file) => {
        validateAndSetFile(file)
    }

    const handleDrop = (e) => {
        e.preventDefault()
        setDragOver(false)
        const file = e.dataTransfer.files[0]
        if (file) handleFile(file)
    }

    const handleChange = (e) => {
        const file = e.target.files?.[0]
        if (file) handleFile(file)
    }

    const fetchActivities = async () => {
        try {
            await fetch(API_BASE_URL)
        } catch (err) {
            console.error("Failed to fetch activities list:", err)
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (!editingId && !selectedFile) {
            setErrorMessage("Please select a valid photo file.")
            setState("error")
            return
        }

        const isStandardDistrict = ["320A", "320B", "320C", "320D", "320E", "320F", "320G", "320H"].includes(district);
        if (!district || !caption || (isStandardDistrict && !activity)) {
            setErrorMessage("Please fill all required fields.")
            setState("error")
            return
        }

        setState("uploading")
        setProgress(30)

        const formData = new FormData()
        formData.append("caption", caption)
        formData.append("district", district)
        // If it's a non-standard district, send "N/A" so the backend doesn't throw a 400 error
        formData.append("activity", isStandardDistrict ? activity : "N/A")

        if (selectedFile) {
            formData.append("photo", selectedFile)
        }

        try {
            setProgress(60)
            let res;
            if (editingId) {
                res = await fetch(`${API_BASE_URL}/${editingId}`, {
                    method: "PUT",
                    body: formData,
                })
            } else {
                res = await fetch(API_BASE_URL, {
                    method: "POST",
                    body: formData,
                })
            }

            if (!res.ok) throw new Error("Operation failed on the server")

            setProgress(100)
            setState("success")
            fetchActivities()
        } catch (err) {
            setErrorMessage(err.message)
            setState("error")
        }
    }

    const reset = () => {
        setState("idle")
        setProgress(0)
        setFilename("")
        setCaption("")
        setDistrict("")
        setActivity("")
        setSelectedFile(null)
        setErrorMessage("")
        setEditingId(null)
        if (inputRef.current) inputRef.current.value = ""
    }

    // Determine if service activity should be shown based on selected district
    const standardDistricts = ["320A", "320B", "320C", "320D", "320E", "320F", "320G", "320H"];
    const showServiceActivity = standardDistricts.includes(district);

    return (
        <>
            <TopNavbar />
            <div style={{ fontFamily: "inherit" }}>

                <div style={{ backgroundColor: "#0067B1", padding: "48px 0" }}>
                    <div style={{ maxWidth: "1280px", margin: "0 auto", paddingLeft: "16px", paddingRight: "16px" }}>
                        <nav style={{ display: "flex", alignItems: "center", gap: "8px", fontSize: "14px", color: "rgba(255, 255, 255, 0.8)", marginBottom: "12px" }}>
                            <a href="/" style={{ color: "#ffffff", textDecoration: "none" }}>Home</a>
                            <span>/</span>
                            <span style={{ color: "rgba(255, 255, 255, 0.6)" }}>Upload</span>
                        </nav>
                        <h1 style={{ fontSize: "36px", fontWeight: 800, color: "#ffffff", marginTop: "16px" }}>Upload Service Activity Photo</h1>
                        <p style={{ color: "rgba(255, 255, 255, 0.7)", marginTop: "8px", fontSize: "16px" }}>Submit district service activities, photos, and reports to MD 320.</p>
                    </div>
                </div>

                <section style={{ padding: "64px 0", backgroundColor: "#f9fafb", minHeight: "60vh" }}>
                    <div style={{ maxWidth: "672px", margin: "0 auto", paddingLeft: "16px", paddingRight: "16px" }}>
                        {state === "idle" && (
                            <form onSubmit={handleSubmit} style={{ backgroundColor: "#ffffff", borderRadius: "16px", border: "1px solid #f3f4f6", boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)", padding: "32px", display: "flex", flexDirection: "column", gap: "24px" }}>
                                <div>
                                    <label style={{ display: "block", fontWeight: 700, color: "#1f2937", marginBottom: "8px" }}>Upload Photo <span style={{ color: "#ef4444" }}>*</span></label>
                                    <p style={{ fontSize: "12px", color: "#9ca3af", marginBottom: "12px" }}>Please upload only PNG, JPG, GIF AND JPEG Files and size must be 2 MB</p>
                                    <div style={{ position: "relative", borderRadius: "12px", border: `2px dashed ${dragOver ? "#0067B1" : "#e5e7eb"}`, transition: "all 0.2s", padding: "32px", textAlign: "center", cursor: "pointer", backgroundColor: dragOver ? "#f0f7ff" : "#ffffff", }} onDragOver={(e) => { e.preventDefault(); setDragOver(true) }} onDragLeave={() => setDragOver(false)} onDrop={handleDrop} onClick={() => inputRef.current?.click()}>
                                        <input ref={inputRef} type="file" style={{ display: "none" }} onChange={handleChange} accept=".png,.jpg,.jpeg,.gif" />
                                        <div style={{ width: "64px", height: "64px", backgroundColor: "#f0f7ff", borderRadius: "16px", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px auto", color: "#0067B1" }}>
                                            <svg style={{ width: "32px", height: "32px" }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" />
                                            </svg>
                                        </div>
                                        {Boolean(filename) ? (
                                            <p style={{ fontSize: "14px", fontWeight: 600, color: "#0067B1" }}>{filename}</p>
                                        ) : (
                                            <>
                                                <p style={{ fontSize: "14px", fontWeight: 500, color: "#374151", marginBottom: "4px" }}>Drag and drop your photo here, or click to browse</p>
                                                <p style={{ fontSize: "12px", color: "#9ca3af" }}>Max size: 2 MB</p>
                                            </>
                                        )}
                                    </div>
                                </div>

                                <div>
                                    <label style={{ display: "block", fontWeight: 700, color: "#1f2937", marginBottom: "8px" }} htmlFor="caption">Add your Caption Here <span style={{ color: "#ef4444" }}>*</span></label>
                                    <textarea id="caption" rows={3} value={caption} onChange={(e) => setCaption(e.target.value)} placeholder="Provide a short description or caption for this photo..." required style={{ width: "100%", border: "1px solid #e5e7eb", borderRadius: "8px", padding: "12px", fontSize: "14px", outline: "none", boxSizing: "border-box", }} />
                                </div>

                                <div>
                                    <label style={{ display: "block", fontWeight: 700, color: "#1f2937", marginBottom: "8px" }} htmlFor="district">Districts <span style={{ color: "#ef4444" }}>*</span></label>
                                    <select id="district" value={district} onChange={(e) => {
                                        setDistrict(e.target.value);
                                        setActivity(""); // Reset activity when district changes
                                    }} required style={{ width: "100%", border: "1px solid #e5e7eb", borderRadius: "8px", padding: "12px", fontSize: "14px", backgroundColor: "#ffffff", outline: "none", color: "#374151", boxSizing: "border-box", }}>
                                        <option value="">---SELECT DISTRICT---</option>
                                        {districtsList.map((d) => (<option key={d} value={d}>{d}</option>))}
                                    </select>
                                </div>

                                <div style={{ display: showServiceActivity ? "block" : "none" }}>
                                    <label style={{ display: "block", fontWeight: 700, color: "#1f2937", marginBottom: "8px" }} htmlFor="activity">Service Activity <span style={{ color: "#ef4444" }}>*</span></label>
                                    <select id="activity" value={activity} onChange={(e) => setActivity(e.target.value)} required={showServiceActivity} style={{ width: "100%", border: "1px solid #e5e7eb", borderRadius: "8px", padding: "12px", fontSize: "14px", backgroundColor: "#ffffff", outline: "none", color: "#374151", boxSizing: "border-box", }}>
                                        <option value="">---Select Activity---</option>
                                        {serviceActivities.map((act) => (
                                            <option key={act} value={act}>
                                                {act}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <button type="submit" style={{ width: "100%", backgroundColor: "#FFD500", color: "#0067B1", fontWeight: 700, padding: "14px", borderRadius: "8px", letterSpacing: "0.05em", border: "none", cursor: "pointer", boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1)", textAlign: "center", }}>Submit</button>
                            </form>
                        )}

                        {state === "uploading" && (
                            <div style={{ backgroundColor: "#ffffff", borderRadius: "16px", border: "1px solid #f3f4f6", boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)", padding: "40px", textAlign: "center" }}>
                                <div style={{ width: "64px", height: "64px", backgroundColor: "#f0f7ff", borderRadius: "16px", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 20px auto" }}>
                                    <svg style={{ width: "28px", height: "28px", color: "#0067B1" }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" />
                                    </svg>
                                </div>
                                <h2 style={{ fontSize: "20px", fontWeight: 800, color: "#0067B1", marginBottom: "4px" }}>Uploading...</h2>
                                <p style={{ color: "#9ca3af", fontSize: "14px", marginBottom: "24px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: "320px", margin: "0 auto 24px auto" }}>{filename}</p>
                                <div style={{ width: "100%", backgroundColor: "#f3f4f6", borderRadius: "9999px", height: "10px", marginBottom: "8px", overflow: "hidden" }}>
                                    <div style={{ backgroundColor: "#0067B1", height: "10px", borderRadius: "9999px", transition: "width 0.3s", width: `${Math.min(progress, 100)}%`, }} />
                                </div>
                                <p style={{ fontSize: "12px", color: "#9ca3af", fontWeight: 500 }}>{Math.min(progress, 100)}% complete</p>
                            </div>
                        )}

                        {state === "success" && (
                            <div style={{ backgroundColor: "#ffffff", borderRadius: "16px", border: "1px solid #d1fae5", boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)", padding: "40px", textAlign: "center" }}>
                                <div style={{ width: "64px", height: "64px", backgroundColor: "#ecfdf5", borderRadius: "16px", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 20px auto" }}>
                                    <svg style={{ width: "32px", height: "32px", color: "#10b981" }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
                                    </svg>
                                </div>
                                <h2 style={{ fontSize: "24px", fontWeight: 800, color: "#111827", marginBottom: "8px" }}>Upload Successful</h2>
                                <p style={{ color: "#6b7280", fontSize: "14px", marginBottom: "4px" }}>Your service activity photo has been received by MD 320.</p>
                                <p style={{ color: "#9ca3af", fontSize: "12px", marginBottom: "28px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: "320px", margin: "0 auto 28px auto" }}>{filename}</p>

                                <div style={{ backgroundColor: "#f9fafb", borderRadius: "8px", padding: "16px", textAlign: "left", marginBottom: "28px" }}>
                                    <div style={{ fontSize: "12px", fontWeight: 700, letterSpacing: "0.05em", textTransform: "uppercase", color: "#9ca3af", marginBottom: "8px" }}>Submission Details</div>
                                    <div style={{ fontSize: "12px", color: "#4b5563", marginBottom: "4px" }}><strong>District:</strong> {district}</div>
                                    {showServiceActivity && <div style={{ fontSize: "12px", color: "#4b5563", marginBottom: "4px" }}><strong>Activity:</strong> {activity}</div>}
                                    <div style={{ fontSize: "12px", fontFamily: "monospace", color: "#374151", marginTop: "8px" }}><strong>Ref ID:</strong> MD320-{Date.now().toString(36).toUpperCase()}</div>
                                </div>

                                <button onClick={reset} style={{ backgroundColor: "#0067B1", color: "#ffffff", fontWeight: 700, padding: "12px 28px", borderRadius: "8px", letterSpacing: "0.05em", border: "none", cursor: "pointer", }}>Upload Another</button>
                            </div>
                        )}

                        {state === "error" && (
                            <div style={{ backgroundColor: "#ffffff", borderRadius: "16px", border: "1px solid #fee2e2", boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)", padding: "40px", textAlign: "center" }}>
                                <div style={{ width: "64px", height: "64px", backgroundColor: "#fef2f2", borderRadius: "16px", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 20px auto" }}>
                                    <svg style={{ width: "32px", height: "32px", color: "#ef4444" }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                </div>
                                <h2 style={{ fontSize: "24px", fontWeight: 800, color: "#111827", marginBottom: "8px" }}>Upload Failed</h2>
                                <p style={{ color: "#6b7280", fontSize: "14px", marginBottom: "24px" }}>{errorMessage || "Something went wrong. Please check your file requirements and try again."}</p>

                                <div style={{ display: "flex", gap: "12px", justifyContent: "center" }}>
                                    <button onClick={() => { setState("idle"); setFilename(""); setSelectedFile(null); }} style={{ backgroundColor: "#0067B1", color: "#ffffff", fontWeight: 700, padding: "10px 24px", borderRadius: "8px", letterSpacing: "0.05em", border: "none", cursor: "pointer", }}>Try Again</button>
                                    <button onClick={reset} style={{ backgroundColor: "transparent", border: "1px solid #e5e7eb", color: "#4b5563", fontWeight: 600, padding: "10px 24px", borderRadius: "8px", cursor: "pointer", }}>Cancel</button>
                                </div>
                            </div>
                        )}

                        {state === "idle" && (
                            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))", gap: "16px", marginTop: "32px" }}>
                                {[
                                    { icon: "🔒", title: "Secure Transfer", desc: "All uploads are encrypted in transit and at rest." },
                                    { icon: "⚡", title: "Fast Processing", desc: "Photos are processed and cataloged within minutes." },
                                    { icon: "📋", title: "Organized Storage", desc: "Files are automatically categorized by district and activity." },
                                ].map((item) => (
                                    <div key={item.title} style={{ backgroundColor: "#ffffff", borderRadius: "12px", padding: "20px", border: "1px solid #f3f4f6", textAlign: "center" }}>
                                        <div style={{ fontSize: "24px", marginBottom: "8px" }}>{item.icon}</div>
                                        <div style={{ fontWeight: 600, color: "#1f2937", fontSize: "14px", marginBottom: "4px" }}>{item.title}</div>
                                        <div style={{ color: "#9ca3af", fontSize: "12px", lineHeight: "1.5" }}>{item.desc}</div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </section>
            </div>
            <Footer />
        </>
    )
}